export const QTY_LIMIT = 25;
export const YES = 'YES';
export const NO = 'NO';
export const REQUEST = 'request';
export const RENT = 'rent';
export const NOT_AVAILABLE = 'not available';
export const IMAGE_SPECS = {
    HEIGHT: 56,
    WIDTH: 56
}
export const imageStaticPath = 'catClass';
export const THROTTLE_DELAYS = {
    INPUT_BOX: 800,
    INC_DEC_BUTTON: 500
};
export const CONSUMABLES_LISTING_VIEW_COUNTS = {
    COLUMNS: {
        DESKTOP: 3,
        TABLET: 2,
        MOBILE: 1
    }
}
export const SEE_MORE_CONTAINER_HEIGHT = {
    TABLET: 430,
    MOBILE: 406
};
export const PDP_NAV_PROPERTIES = {
    SCROLL_THROTTLE_DELAY: 300,
    SECTION_BOTTOM_POSITION: 150
}